import { useState } from 'react';
import Div from '../../common/components/div';
import H1 from '../../common/components/h1';
import translate from '../../common/functions/translate';
import { usePageViewWithSteps } from '../../common/hooks/use.analytics';
import { usePageTitle } from '../../common/hooks/usePageTitle';
import { CreateOrUnlockAccountDataProvider, useCreateOrUnlockAccountData } from '../../create-account/createAccountContext';
import UpdatePasswordAndSecretQuestion, { UpdatePasswordAndSecretQuestionErrorKeys, UpdatePasswordAndSecretQuestionErrorKeysHeaders } from './UpdatePasswordAndSecretQuestion';
import YourBasicInformation, { UnlockBasicInformationErrorHeaderKeys, UnlockBasicInformationErrorKeys } from './YourBasicInformation';
import YourMedicareInformation from './YourMedicareInformation';

interface UnlockAccountProps {
  testInitialErrorState?: UnlockBasicInformationErrorKeys & UpdatePasswordAndSecretQuestionErrorKeys & UpdatePasswordAndSecretQuestionErrorKeysHeaders
  basicInfoHeaders?: UnlockBasicInformationErrorHeaderKeys
  updatePasswordAndSecretHeaders?: UpdatePasswordAndSecretQuestionErrorKeysHeaders
}

export default function UnlockAccount(props: UnlockAccountProps) {
    usePageTitle(translate('unlock_account'));

    const [step, setStep] = useState(1);
    const { data, updateData } = useCreateOrUnlockAccountData();

    const stepTitle = {
        1: 'Your Medicare information',
        2: 'Your basic information',
        3: 'Update password & secret question',
    };

    const getStep = () => {
        switch (step) {
            case 1:
                return <YourMedicareInformation />;
            case 2:
                return <YourBasicInformation basicInfoHeaders={props.basicInfoHeaders} testInitialErrorState={props.testInitialErrorState} />;
            case 3:
                return <UpdatePasswordAndSecretQuestion updatePasswordAndSecretHeaders={props.updatePasswordAndSecretHeaders} testInitialErrorState={props.testInitialErrorState}/>;
            default:
                return <YourMedicareInformation/>;
        }
    };

    usePageViewWithSteps('Unlock account', step, stepTitle[step as (1 | 2 | 3)]);

    return <CreateOrUnlockAccountDataProvider value={{
        data,
        updateData,
        stepForward: () => setStep(currentStep => currentStep + 1),
        stepBackward: () => setStep(currentStep => currentStep - 1)
    }}>
        <Div
            isContainer={true}
            paddingySM={1} paddingyMD={2} paddingyLG={3} paddingyXL={4}
        >
            <H1>{translate('unlock_account')}</H1>
            <Div marginTop={3}>
                <p className='ds-text-heading--sm'>
                    {translate('step_of', { step: step, steps: '3'})}
                </p>
            </Div>
            {getStep()}
        </Div>
    </CreateOrUnlockAccountDataProvider>;
}
